import { render, staticRenderFns } from "./ConfirmResult.vue?vue&type=template&id=53e06e00&"
import script from "./ConfirmResult.vue?vue&type=script&lang=js&"
export * from "./ConfirmResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports